import { Component, input } from '@angular/core';
import { ParagraphPgVi } from '@app/models/paragraph.model';
import { MediaComponent } from '@app/components/media/media.component';
import { EntitySharedModule } from '@app/modules/entity.shared.module';
import { MediaLayoutComponent } from '@app/components/media-layout/media-layout.component';
import { TextComponent } from '@app/components/text/text.component';

@Component({
  selector: 'mobi-paragraph-pg-vi',
  templateUrl: './paragraph-pg-vi.component.html',
  styleUrls: ['./paragraph-pg-vi.component.scss'],
  standalone: true,
  imports: [EntitySharedModule, MediaLayoutComponent, MediaComponent, TextComponent],
})
export class ParagraphPgViComponent {
  readonly paragraph = input.required<ParagraphPgVi>();
}
